<script setup>
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useI18n } from 'vue-i18n';

defineProps({
  isGeneratingContent: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['submit', 'cancel', 'report', 'send-bubbles']);
const { t } = useI18n();

const handleCancel = () => {
  emit('cancel');
};

const handleReport = () => {
  emit('report');
};

const handleSubmit = () => {
  emit('submit');
};

const handleSendBubbles = () => {
  emit('send-bubbles');
};
</script>

<template>
  <div class="flex justify-between items-center gap-2 p-3 pt-0">
    <div class="flex items-center gap-1">
      <NextButton
        :label="t('GENERAL.DISCARD')"
        slate
        link
        class="!px-1 hover:!no-underline"
        sm
        :disabled="isGeneratingContent"
        @click="handleCancel"
      />
      <NextButton
        :label="t('CONVERSATION.REPLYBOX.COPILOT.REPORT')"
        slate
        link
        class="!px-1 hover:!no-underline"
        sm
        :disabled="isGeneratingContent"
        @click="handleReport"
      />
    </div>
    <div class="flex items-center gap-2">
      <NextButton
        :label="t('CONVERSATION.REPLYBOX.COPILOT.EDIT')"
        faded
        slate
        sm
        :disabled="isGeneratingContent"
        @click="handleSubmit"
      />
      <NextButton
        :label="t('CONVERSATION.REPLYBOX.COPILOT.SEND')"
        class="bg-n-iris-9 text-white"
        solid
        sm
        :disabled="isGeneratingContent"
        @click="handleSendBubbles"
      />
    </div>
  </div>
</template>
